import React, { useEffect, useRef, useState } from 'react';
import { PDFDownloadLink, PDFViewer } from '@react-pdf/renderer';
import { useSelector } from 'react-redux';
import { RootState } from '../store';
import { Color } from '../interfaces/store';
// @ts-ignore
import { throttle } from 'throttle-debounce';
import { DefaultPdf } from './DefaultPdf';

const PdfIframePreview: React.FC<Color> = (props: Color) => {
  const personaData = useSelector((state: RootState) => state.personal);
  const experiencesData = useSelector((state: RootState) => state.experienceSlice);
  const skills = useSelector((state: RootState) => state.skillSlice);
  const languages = useSelector((state: RootState) => state.languageSlice);
  const courses = useSelector((state: RootState) => state.courseSlice);
  const links = useSelector((state: RootState) => state.linkSlice);
  const hobbies = useSelector((state: RootState) => state.hobbySlice);
  const themes = useSelector((state: RootState) => state.themeSlice);
  const payment = useSelector((state: RootState) => state.paymentSlice);

  const [throttledPersonaData, setThrottledPersonaData] = useState(personaData);
  const [throttledExperiencesData, setThrottledExperiencesData] = useState(experiencesData);

  const prevPersonaRef = useRef(personaData);
  const prevExperienceRef = useRef(experiencesData);

  // Separate throttles for each data type
  const throttledUpdatePersona = useRef(
    throttle(1000, (newData: typeof personaData) => {
      setThrottledPersonaData(newData);
    })
  );

  const throttledUpdateExperiences = useRef(
    throttle(1000, (newData: typeof experiencesData) => {
      setThrottledExperiencesData(newData);
    })
  );

  useEffect(() => {
    const prevPersonaData = prevPersonaRef.current;
    const prevExperiencesData = prevExperienceRef.current;

    if (prevPersonaData !== personaData) {
      throttledUpdatePersona.current(personaData);
      prevPersonaRef.current = personaData;
    }

    if (prevExperiencesData !== experiencesData) {
      throttledUpdateExperiences.current(experiencesData);
      prevExperienceRef.current = experiencesData;
    }
  }, [personaData, experiencesData]);

  // Optional safety guard to avoid crash on wrong prop shape
  if (Array.isArray(throttledPersonaData)) {
    console.error('Invalid personaData passed to DefaultPdf:', throttledPersonaData);
    return null;
  }

  const pdf = <DefaultPdf
      skills={skills}
      personaData={throttledPersonaData}
      primaryColor={themes.primaryColor}
      secondaryColor={themes.secondaryColor}
      fontColor={themes.fontColor}
      experiences={throttledExperiencesData}
      languages={languages}
      courses={courses}
      links={links}
      hobbies={hobbies}
    />

  console.log(payment)
  if (payment.succeed) {
    return <PDFDownloadLink document={pdf} fileName={personaData.name ? `${personaData.name}.pdf` : 'cv.pdf'}>
    {({ blob, url, loading, error }) => (loading ? <span>Loading document...</span> : <span>Download Document</span>)}
  </PDFDownloadLink>
  }

  return (
    <PDFViewer key='testing' width="100%" height={window.innerHeight} showToolbar={false}>
      {pdf}
    </PDFViewer>
  );
};

export default PdfIframePreview;
